import type { TFunction } from 'i18next'

import { CheckIcon, ClockIcon, XIcon } from 'lucide-react'

import { ANCHOR_STATUS } from '@/entities/anchor'

export const getAnchorStatusChoices = (t: TFunction) => [
	{
		value: ANCHOR_STATUS.APPROVED,
		label: t('approved'),
		variant: 'success',
		icon: <CheckIcon />,
	},
	{
		value: ANCHOR_STATUS.REJECTED,
		label: t('rejected'),
		variant: 'destructive',
		icon: <XIcon />,
	},
	{
		value: ANCHOR_STATUS.REVIEW,
		label: t('app.review', { defaultValue: 'Review' }),
		variant: 'warning',
		icon: <ClockIcon />,
	},
]
